import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken, RadiusToken, ShadowToken } from "@livechat/design-system-react-components";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { DropdownDirection, DropdownPlacement } from "components/dropdown/Dropdown";
import { withVar } from "themes/helpers";

interface IProps {
  isVisible: boolean;
  xPosition: number;
  yPosition: number;
  children: React.ReactNode;
  direction: DropdownDirection;
  shadow?: DropdownShadow;
  placement?: DropdownPlacement;
  chevronPosition?: string;
  contentRef(el: HTMLDivElement): void;
}

export enum DropdownShadow {
  Light,
  Strong,
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface StyledDropdownBoxProps {
  shadow: DropdownShadow;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface StyledDropdownContentProps {
  isVisible: boolean;
  xPosition: number;
  yPosition: number;
  direction: DropdownDirection;
  placement?: DropdownPlacement;
  chevronPosition?: string;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const directionRight = () => `
  margin-left: 7px;

  &::before {
    top: 50%;
    left: -14px;
    transform: translateY(-50%);
    border-color: transparent ${withVar(DesignToken.ContentInvertPrimary)} transparent transparent;
  }
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const directionBottom = () => `
  &::before {
    top: -14px;
    left: 50%;
    transform: translateX(-50%);
    border-color: transparent transparent ${withVar(DesignToken.ContentInvertPrimary)} transparent;
  }
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const placementTop = (props: any) => `
  &::before {
    top: ${props.chevronPosition || "10px"};
  }
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const placementBottom = (props: any) => `
  &::before {
    top: auto;
    bottom: ${props.chevronPosition || "10px"};
  }
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const placementLeft = (props: any) => `
  &::before {
    left: ${props.chevronPosition || "20px"};
  }
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const placementRight = (props: any) => `
  &::before {
    left: auto;
    right: ${props.chevronPosition || "20px"};
  }
`;

const StyledDropdownContent = styled.div<StyledDropdownContentProps>`
  position: fixed;
  white-space: nowrap;
  top: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => `${props.yPosition}px`
  };
  left: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => `${props.xPosition}px`
  };
  visibility: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? "visible" : "hidden")
  };
  opacity: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? 1 : 0)
  };

  &::before {
    content: " ";
    position: absolute;
    height: 0;
    border-width: 7px;
    border-style: solid;
    z-index: 10;
  }

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => {
      if (props.direction === DropdownDirection.Right) {
        return directionRight;
      }
      if (props.direction === DropdownDirection.Bottom) {
        return directionBottom;
      }
      return "";
    }
  };

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => {
      switch (props.placement) {
        case DropdownPlacement.Top:
          return placementTop;
        case DropdownPlacement.Bottom:
          return placementBottom;
        case DropdownPlacement.Left:
          return placementLeft;
        case DropdownPlacement.Right:
          return placementRight;
        default:
          return "";
      }
    }
  };
`;

const StyledDropdownBox = styled.div<StyledDropdownBoxProps>`
  position: relative;
  border-radius: ${withVar(RadiusToken.Radius3)};
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  box-shadow: ${withVar(ShadowToken.PopOver)};
`;

export const DropdownContent: React.FC<IProps> = ({
  isVisible,
  xPosition,
  yPosition,
  contentRef,
  children,
  direction,
  placement,
  shadow,
  chevronPosition,
}) => (
  <StyledDropdownContent
    ref={contentRef}
    isVisible={isVisible}
    xPosition={xPosition}
    yPosition={yPosition}
    direction={direction}
    placement={placement || DropdownPlacement.Center}
    chevronPosition={chevronPosition}
  >
    {/* @ts-expect-error TS(2322) */}
    <StyledDropdownBox shadow={shadow}>{children}</StyledDropdownBox>
  </StyledDropdownContent>
);
